module.exports = __webpack_public_path__ + "img/la_region_du_gout.ad68750c.png";